// extracted by mini-css-extract-plugin
export default {"strokeMarketplaceColor":"IconKeys_strokeMarketplaceColor__j00xo"};